import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EtapaProcesso } from '../models/etapa-processo.model';
import { EtapaAtivaProcesso } from '../models/etapa-ativa-processo.model';
import { EtapaProcessoRepository } from '../repositories/etapa-processo.repository';
import { DEFAULT_PAGINATION_PARAMS, PaginatedResponse } from '../../../core/shared/models/pagination.model';
import { EtapaListParams } from '../models/etapa-list-params.model';

@Injectable({
  providedIn: 'root'
})
export class EtapaProcessoService implements EtapaProcessoRepository {
  private readonly apiEtapaProcesso = 'etapas/';

  constructor(private readonly http: HttpClient) { }

  listarEtapasProcesso(params: EtapaListParams = DEFAULT_PAGINATION_PARAMS): Observable<PaginatedResponse<EtapaProcesso>> {
    let queryParams = new HttpParams()
      .set('page', params.page)
      .set('size', params.size);

    if (params.nome) {
      queryParams = queryParams.set('nome', params.nome);
    }

    if (params.status) {
      queryParams = queryParams.set('status', params.status);
    }

    return this.http.get<PaginatedResponse<EtapaProcesso>>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiEtapaProcesso}listarTodos`,
      { params: queryParams }
    );
  }

  buscarEtapaProcessoPorId(idEtapa: number): Observable<EtapaProcesso> {
    return this.http.get<EtapaProcesso>(`${environment.FI_FINANC_IMOB_BE}${this.apiEtapaProcesso}buscar/${idEtapa}`);
  }

  criarEtapaProcesso(payload: EtapaProcesso): Observable<EtapaProcesso> {
    return this.http.post<EtapaProcesso>(`${environment.FI_FINANC_IMOB_BE}${this.apiEtapaProcesso}criar`, payload);
  }

  editarEtapaProcesso(idEtapa: number, payload: EtapaProcesso): Observable<EtapaProcesso> {
    return this.http.put<EtapaProcesso>(`${environment.FI_FINANC_IMOB_BE}${this.apiEtapaProcesso}atualizar/${idEtapa}`, payload);
  }

  excluirEtapaProcesso(idEtapa: number): Observable<void> {
    return this.http.delete<void>(`${environment.FI_FINANC_IMOB_BE}${this.apiEtapaProcesso}deletar/${idEtapa}`);
  }

  listarEtapasAtivasProcesso(idProposta: number): Observable<EtapaAtivaProcesso[]> {
    return this.http.get<EtapaAtivaProcesso[]>(`${environment.FI_FINANC_IMOB_BE}${this.apiEtapaProcesso}processo/${idProposta}/ativas`);
  }
}
